import React, { useState, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import InputDefault from '../../../../components/InputDefault/index.js';
import SelectDefault from '../../../../components/SelectDefault/index.js';
import ButtonDefault from '../../../../components/ButtonDefault/index.js';
import ButtonAction from '../../../../components/ButtonAction/index.js';
import LoadingCard from './LoadingCard';
import { CardContainer, CardHeader, CardBody, FormGroup, TableContainer, SectionTitle } from './CardStyles';
import api from '../../../../services/api.js';
import moment from 'moment';

const StudyDataCard = ({ idDm013, onDataUpdate, onModalOpen }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [studyData, setStudyData] = useState({
    dtEstudoDm013: '',
    nmUsuarioEstudo: '',
    idUsuarioEstudo: '',
    jsonMeasureDm013: [],
    measureAvgDm013: 0,
    dtDeDm013: '',
    dtAteDm013: '',
    inTipoMedicaoDm013: ''
  });

  const formatDate = (dateStr) => {
    if (dateStr === '' || dateStr === null) {
      return '';
    }
    return moment(dateStr).format('YYYY-MM-DD');
  };

  const formatNumberBr = (number) => {
    return Number(number).toFixed(2).replace('.', ',');
  };

  useEffect(() => {
    const fetchStudyData = async () => {
      if (!idDm013) {
        setIsLoading(false);
        return;
      }
      
      try {
        setIsLoading(true);
        const feasibilityResponse = await api.get(`feasibility_study?ID_DM013=${idDm013}`);
        const data = feasibilityResponse.data.data[0];
        
        if (feasibilityResponse.status === 200) {
          const jsonString = data.JS_MEDICAO || '{}';
          let jsonData = [];
          let measureAvg = 0;
          
          try {
            jsonData = JSON.parse(jsonString);
            if (Object.keys(jsonData).length === 0 || !Array.isArray(jsonData)) {
              measureAvg = data.JS_MEDICAO;
              jsonData = [];
            } else {
              jsonData.sort((a, b) => a.id - b.id);
            }
          } catch (error) {
            measureAvg = data.JS_MEDICAO;
            jsonData = [];
          }

          const updatedData = {
            idDm011: data.ID_DM011,
            dtEstudoDm013: formatDate(data.DT_ESTUDO),
            nmUsuarioEstudo: data.NM_USUARIO_ESTUDO,
            idUsuarioEstudo: data.ID_DM900,
            jsonMeasureDm013: jsonData,
            measureAvgDm013: measureAvg,
            dtDeDm013: data.NR_ANOMES_DE,
            dtAteDm013: data.NR_ANOMES_ATE,
            inTipoMedicaoDm013: data.IN_TIPO_MEDICAO
          };
          
          setStudyData(updatedData);
          onDataUpdate(updatedData);
        }
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.error('Erro ao buscar dados do estudo:', error);
      }
    };

    fetchStudyData();
  }, [idDm013, onDataUpdate]);

  const handleChange = (field, value) => {
    const updatedData = { ...studyData, [field]: value };
    setStudyData(updatedData);
    onDataUpdate(updatedData);
  };

  const handleDeleteMeasure = (measureId) => {
    const updatedJson = studyData.jsonMeasureDm013.filter((item) => item.id !== measureId);
    updatedJson.sort((a, b) => a.id - b.id);
    const updatedData = { ...studyData, jsonMeasureDm013: updatedJson };
    setStudyData(updatedData);
    onDataUpdate(updatedData);
  };

  if (isLoading) {
    return <LoadingCard title="Carregando Dados do Estudo..." />;
  }

  if (!idDm013) {
    return <LoadingCard title="Aguardando dados do contrato..." />;
  }

  return (
    <CardContainer>
      <CardHeader>
        <h5>Dados do Estudo ({idDm013})</h5>
      </CardHeader>
      <CardBody>
        <Row>
          <Col xs={12} md={4}>
            <FormGroup>
              <InputDefault
                placeholder=""
                Width={'100%'}
                Margin={'0'}
                value={studyData.dtEstudoDm013}
                onChange={(e) => handleChange('dtEstudoDm013', e.target.value)}
                Text={'Data do Estudo'}
                type={'date'}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={4}>
            <InputDefault
              placeholder=""
              Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={studyData.dtDeDm013}
              onChange={(e) => handleChange('dtDeDm013', e.target.value)}
              Text={'Mês/Ano de'}
            />
          </Col>
          <Col xs={12} md={4}>
            <InputDefault
              placeholder=""
              Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={studyData.dtAteDm013}
              onChange={(e) => handleChange('dtAteDm013', e.target.value)}
              Text={'Mês/Ano até'}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6}>
            <InputDefault
              placeholder=""
              Width={'100%'}
              Margin={'15px 15px 15px 0px'}
              value={`${studyData.nmUsuarioEstudo} (${studyData.idUsuarioEstudo})`}
              Text={'Usuário do Estudo'}
              readOnly
            />
          </Col>
        </Row>
        
        <SectionTitle>Medição</SectionTitle>
        <Row>
          <Col xs={12} md={6}>
            <FormGroup>
              <SelectDefault
                Width={'100%'}
                Margin={'0'}
                Text={'Tipo de Medição'}
                value={`${studyData.inTipoMedicaoDm013}`}
                onChange={(e) => handleChange('inTipoMedicaoDm013', e.target.value)}>
                <option value="1">CONSUMO MENSAL</option>
                <option value="2">CONSUMO MÉDIO</option>
              </SelectDefault>
            </FormGroup>
          </Col>
        </Row>
            <Row>
              {studyData.inTipoMedicaoDm013 === '2' ? (
                <Col xs={12} md={6}>
                  <InputDefault
                    placeholder=""
                    Width={'100%'}
                    Margin={'15px 15px 15px 0px'}
                    value={studyData.measureAvgDm013}
                    Text={'Consumo Médio'}
                    onChange={(e) => handleChange('measureAvgDm013', e.target.value)}
                    type={'number'}
                  />
                </Col>
              ) : (
                <>
                  <Row>
                    <Table
                      striped
                      bordered
                      hover
                      variant="light"
                      style={{
                        marginLeft: '10px',
                        width: '500px'
                      }}>
                      <thead>
                        <tr>
                          <th style={{ width: '5%', textAlign: 'right' }}>Mês</th>
                          <th style={{ width: '20%' }}>Mês/Ano da Fatura</th>
                          <th style={{ width: '10%' }}>Medição</th>
                          <th style={{ width: '5%', textAlign: 'center' }}>Ação</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(studyData.jsonMeasureDm013 || []).map((measure, index) => (
                          <tr key={measure.id}>
                            <td style={{ textAlign: 'right' }}>{measure.id}</td>
                            <td>{measure.date}</td>
                            <td>{formatNumberBr(measure.measure)}</td>
                            <td
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                height: '45px',
                                justifyContent: 'center',
                                gap: 'var(--spacing-xs)'
                              }}>
                              <ButtonAction
                                Action="Remove"
                                onClick={() => {
                                  onModalOpen('deleteMeasure', measure.id);
                                }}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Row>
                  <Row>
                    <ButtonDefault
                      Width={'200px'}
                      Margin={'0px 0px 10px 10px'}
                      Text="Adicionar Medição"
                      onClick={() => {
                        onModalOpen('addMeasure');
                      }}
                    />
                  </Row>
                </>
              )}
            </Row>
      </CardBody>
    </CardContainer>
  );
};

export default StudyDataCard;
